<template>
  <div class="reference-form__name">
    <div class="label">
      <button @click="dropdownIsOpen = true">
        <span>
          {{labelToDisplay}}  <i class="material-icons">arrow_drop_down</i>
        </span>
      </button>
      <div v-if="dropdownIsOpen" v-on-clickaway="() => {dropdownIsOpen = false}" class="dropdown">
        <button @click="useLiteralName(false)" :class="{selected:!literalNameIsSelected}">{{label}}</button>
        <button @click="useLiteralName(true)" :class="{selected:literalNameIsSelected}">Organization</button>
      </div>
    </div>
    <div class="input">
      <input v-if="!literalNameIsSelected" type="text" v-model="name.given" placeholder="First name(s)" />
      <input v-if="!literalNameIsSelected" type="text" v-model="name.family" placeholder="Last name"/>
      <input v-if="literalNameIsSelected" type="text" v-model="name.literal" class="expand" placeholder="Company or organization name"/>
      <button class="remove-name-btn red" title="Remove person" @click="$emit('onDelete')"><i class="material-icons">remove_circle_outline</i></button>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'ReferenceFormName',
  props: ['label', 'name'],
  mixins: [clickaway],
  data () {
    return {
      dropdownIsOpen: false,
      literalNameIsSelected: false
    }
  },
  computed: {
    labelToDisplay () {
      return this.literalNameIsSelected ? 'Organization' : this.label
    }
  },
  methods: {
    useLiteralName (useLiteralName) {
      this.literalNameIsSelected = useLiteralName;
      if (useLiteralName) {
        this.name.given = null;
        this.name.family = null;
      } else {
        this.name.literal = null;
      }

      this.dropdownIsOpen = false;
    }
  },
  beforeMount () {
    if (this.name.literal) {
      this.literalNameIsSelected = true;
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';

  .mb-widget {
    .reference-form__name { margin-bottom:10px;
      .label { padding-right:18px; position:relative;  text-transform:uppercase; width:168px;
        >button { font-size:14px; font-weight:700; padding:0; text-transform:uppercase; width:160px; }
        i { margin-right:-8px; }
      }
      .dropdown { background:#ffffff; border-radius:2px; box-shadow:0 1px 6px rgba(0,0,0,.117647), 0 1px 4px rgba(0,0,0,.117647); left:0; position:absolute; top:0; width:200px; z-index:5;
        button { font-size:16px; font-weight:400; justify-content:center; line-height:48px; padding: 0 16px; text-transform:none; width:100%;
          &:hover { background: $ui-grey;}
        }
      }
      input { width:50%;
        &.expand { width:100%; }
      }
    }

    @media screen and (min-width: 60em) {
      .reference-form__name { display:flex;
        .label { align-items:center; display:flex; justify-content:flex-end; text-align:right;
          >button { width:auto; }
        }
        .dropdown button { text-align:left; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ReferenceFormName.vue